"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var frontend_button_1 = require("@ryerson/frontend.button");

var CookieBanner_1 = __importDefault(require("./CookieBanner"));

var HeaderConfig_1 = require("../common/HeaderConfig/HeaderConfig");

var StaticItem_1 = __importDefault(require("../common/StaticItem"));

var StyledComponents_1 = require("./Helpers/StyledComponents");

var PhoneLinkRenderer_1 = require("../Renderers/PhoneLinkRenderer");

var LogoRenderer_1 = require("../Renderers/LogoRenderer");

var StyledComponents_2 = require("./Helpers/StyledComponents");

var Constants_1 = require("../common/Constants");

var MergeCartModal_1 = __importDefault(require("../MergeCartModal/MergeCartModal"));

var frontend_e_commerce_1 = require("@ryerson/frontend.e-commerce");

var frontend_application_1 = require("@ryerson/frontend.application");

var SimpleHeader = function SimpleHeader(_ref) {
  var _ref$storeDirectory = _ref.storeDirectory,
      storeDirectory = _ref$storeDirectory === void 0 ? Constants_1.STORE : _ref$storeDirectory,
      companyName = _ref.companyName,
      _ref$renderMergeCartM = _ref.renderMergeCartModal,
      renderMergeCartModal = _ref$renderMergeCartM === void 0 ? true : _ref$renderMergeCartM;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var _theme$colors$primary = theme.colors.primary,
      link = _theme$colors$primary.link,
      primaryBrand = _theme$colors$primary.primaryBrand,
      gray = _theme$colors$primary.gray;
  var headerSettings = HeaderConfig_1.headerConfigData[companyName];

  var _ref3 = (0, frontend_application_1.useApplication)(),
      country = _ref3.localization.country;

  var _ref4 = (0, frontend_e_commerce_1.useEcommerce)(),
      numberOfItems = _ref4.numberOfItems,
      showMergeCartModal = _ref4.showMergeCartModal,
      setShowMergeCartModal = _ref4.setShowMergeCartModal;

  var renderLogoSection = function renderLogoSection() {
    var isMobile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
      className: "simple-header-logo-container",
      alignItems: "center",
      children: (0, LogoRenderer_1.LogoRenderer)({
        companyName: companyName,
        isMobile: isMobile
      })
    });
  };

  var renderLinksSection = function renderLinksSection() {
    return (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
      className: "all-links-buttons-container",
      alignItems: "center",
      children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
        style: StyledComponents_1.phoneLinkWrapperStyle,
        children: (0, PhoneLinkRenderer_1.renderPhoneLink)(headerSettings, country, "primary")
      }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
        className: "contact-us-container",
        style: StyledComponents_2.itemFlex,
        children: (0, jsx_runtime_1.jsx)(StaticItem_1.default, {
          itemName: "contactUs",
          color: link
        })
      }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
        style: StyledComponents_2.separatorStyle,
        children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          size: "lg",
          color: gray,
          css: {
            opacity: 0.2
          },
          children: "|"
        })
      }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
        style: StyledComponents_2.lastItemFlex,
        children: (0, jsx_runtime_1.jsx)(StaticItem_1.default, {
          itemName: "liveChat",
          color: link,
          type: "tertiary"
        })
      }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
        children: (0, jsx_runtime_1.jsx)(frontend_button_1.Button, {
          label: "",
          onClick: function onClick() {},
          background: primaryBrand,
          size: "sm",
          foreground: "light",
          leftIcon: "comment",
          shape: "circle"
        })
      })]
    });
  };

  return (0, jsx_runtime_1.jsxs)("div", {
    className: "simple-header",
    children: [(0, jsx_runtime_1.jsx)(CookieBanner_1.default, {}), renderMergeCartModal && (0, jsx_runtime_1.jsx)(MergeCartModal_1.default, {
      numberOfItems: numberOfItems,
      showMergeCartModal: showMergeCartModal,
      setShowMergeCartModal: setShowMergeCartModal
    }), (0, jsx_runtime_1.jsx)(frontend_layout_1.Media, {
      lessThan: "lg",
      children: (0, jsx_runtime_1.jsx)(StyledComponents_2.HeaderSection, {
        theme: theme,
        children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Container, {
          vPadding: "0",
          children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
            className: "simple-header-wrapper-mobile",
            justifyContent: "space-between",
            css: {
              height: 50
            },
            children: renderLogoSection(true)
          })
        })
      })
    }), (0, jsx_runtime_1.jsx)(frontend_layout_1.Media, {
      greaterThanOrEqual: "lg",
      children: (0, jsx_runtime_1.jsx)(StyledComponents_2.HeaderSection, {
        theme: theme,
        children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Container, {
          vPadding: "0",
          children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
            className: "simple-header-wrapper-desktop",
            justifyContent: "space-between",
            css: {
              height: 90
            },
            children: [renderLogoSection(), renderLinksSection()]
          })
        })
      })
    })]
  });
};

exports.default = SimpleHeader;